import classNames from 'classnames';
import styles from './ArticleAuthor.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';

export interface ArticleAuthorProps {
	className?: string;
	fullName?: string;
	workTitle?: string;
	bio?: string;
	email?: string;
	showOnlyName?: boolean;
	writtenBy?: string;
}

export const UI_ArticleAuthor = ({ className, fullName, workTitle, email, bio, showOnlyName, writtenBy }: ArticleAuthorProps) => {
	if (showOnlyName) {
		return (
			<footer className={classNames(styles.ArticleAuthor___showOnlyName, className)}>
				{fullName && (
					<UI_Container width={'Standard'}>
						<UI_Paragraph className={styles.ArticleAuthor_fullName}>
							{writtenBy} {fullName}
						</UI_Paragraph>
					</UI_Container>
				)}
			</footer>
		);
	}
	return (
		<footer className={classNames(styles.ArticleAuthor, className)}>
			<UI_Container width={'Standard'}>
				{fullName && <UI_Paragraph>{fullName}</UI_Paragraph>}
				{workTitle && <div className={styles.ArticleAuthor_title}>{workTitle}</div>}
				{email && (
					<div className={styles.ArticleAuthor_email}>
						<UI_Link className={styles.ArticleAuthor_link} url={`mailto:${email}`}>
							{email}
						</UI_Link>
					</div>
				)}
				{bio && <div className={styles.ArticleAuthor_bio}>{bio}</div>}
			</UI_Container>
		</footer>
	);
};
